// extracted by mini-css-extract-plugin
export default {"panelButton":"style_panelButton__CLylY"};